import { Progress as FASTProgressRing } from '@microsoft/fast-components';
import { foundationProgressRingStyles as styles } from './progress-ring.styles';
import { foundationProgressRingTemplate as template } from './progress-ring.template';
/**
 * @tagname %%prefix%%-progress-ring
 */
export class ProgressRing extends FASTProgressRing {
}
// explicitly declaring for extensibility
export const foundationProgressRingShadowOptions = undefined;
export const defaultProgressRingConfig = {
    indeterminateIndicator: `
  <svg class="progress" part="progress" viewBox="0 0 16 16">
    <circle class="background" part="background" cx="8px" cy="8px" r="7px"></circle>
    <circle class="indeterminate-indicator-1" part="indeterminate-indicator-1" cx="8px" cy="8px" r="7px"></circle>
  </svg>
  `,
};
/**
 * The Foundation Progress Ring
 *
 * @public
 * @remarks
 * HTML Element: \<foundation-progress-ring\>
 */
export const foundationProgressRing = ProgressRing.compose(Object.assign({ baseName: 'progress-ring', template,
    styles, shadowOptions: foundationProgressRingShadowOptions }, defaultProgressRingConfig));
